import { useEffect, useState } from "react";
import Switch from "react-switch";
import { AdvancedAISettingType } from "lib/types";
import { Tooltip, Checkbox, Modal } from "antd";
import { SvgToastInfo } from "ui/svgs";
import clsx from "clsx";
export default function AdvancedAISetting(props: {
  camera;
  advancedAISetting: AdvancedAISettingType;
  setAdvancedAISetting: (data: AdvancedAISettingType) => void;
}) {
  const { advancedAISetting, setAdvancedAISetting } = props;
  const [showAiTip, setShowAiTip] = useState(true);
  const [
    showDisableHumanAlertContirmModal,
    setShowDisableHumanAlertContirmModal,
  ] = useState(false);

  useEffect(() => {
    const showAiTip = Boolean(
      parseInt(localStorage.getItem("showAiTip") || "1"),
    );
    setShowAiTip(showAiTip);
  }, []);

  const handleSwitchLPR = () => {
    if (advancedAISetting?.enableVehicle) {
      Modal.confirm({
        title: 'Do you want to disable "Process Human Alerts"?',
        icon: null,
        width: 550,
        content:
          'Disabling "Process Vehicle Alerts" will permanently make "Plate Detection"unavailable until re-enabled.',
        async onOk() {
          setAdvancedAISetting({
            ...advancedAISetting,
            enableVehicle: !advancedAISetting?.enableVehicle,
          });
        },
        okText: "Disable Anyway",
        okButtonProps: {
          className: "primaryButton ",
        },
        cancelButtonProps: {
          className: "primaryButton bordered",
        },
      });
    } else {
      setAdvancedAISetting({
        ...advancedAISetting,
        enableVehicle: !advancedAISetting?.enableVehicle,
      });
    }
  };

  return (
    <div className="w-full h-full">
      <div className="py-2 flex gap-6 justify-center text-base">
        <div className="bg-[#fafafa] p-6 rounded-2xl basis-[33%] ">
          <p className="font-semibold text-xl mb-3">Processor</p>
          <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Human Alerts</span>
            <Switch
              onChange={() => {
                if (!advancedAISetting?.enablePerson) {
                  setAdvancedAISetting({
                    ...advancedAISetting,
                    enablePerson: !advancedAISetting?.enablePerson,
                  });
                } else {
                  setShowDisableHumanAlertContirmModal(true);
                }
              }}
              checked={advancedAISetting?.enablePerson}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Vehicle Alerts</span>
            <Switch
              onChange={handleSwitchLPR}
              checked={advancedAISetting?.enableVehicle}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          <div className="flex items-center justify-between py-3  rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Non Vehicle Alerts</span>
            <Switch
              onChange={() => {
                setAdvancedAISetting({
                  ...advancedAISetting,
                  enableNonMotor: !advancedAISetting?.enableNonMotor,
                });
              }}
              checked={advancedAISetting?.enableNonMotor}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Investigated Alert</span>
            <Switch
              onChange={() => {
                setAdvancedAISetting({
                  ...advancedAISetting,
                  enableCase: !advancedAISetting?.enableCase,
                });
              }}
              checked={advancedAISetting?.enableCase}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          {/* <div className="mt-8 flex justify-between items-center">
        <span>Pitch</span>
        <Select
          style={{ width: "calc(100% - 100px)" }}
          defaultValue={"Medium"}
          value={advancedAISetting?.virtualGuard?.pitch}
          popupClassName="advancedAI-select-dropdown"
          className="h-10 rounded-2xl"
          options={[
            { label: "Medium", value: "Medium" },
            { label: "High", value: "High" },
            { label: "X-High", value: "X-High" },
          ]}
          onChange={(value) => {
            setAdvancedAISetting({
              ...advancedAISetting,
              virtualGuard: {
                ...advancedAISetting?.virtualGuard,
                pitch: value,
              },
            });
          }}
        />
      </div>
      <div className="mt-8 flex justify-between items-center">
        <span>Volume</span>
        <Select
          style={{ width: "calc(100% - 100px)" }}
          defaultValue={"Medium"}
          value={advancedAISetting?.virtualGuard?.volume}
          popupClassName="advancedAI-select-dropdown"
          className="h-10 rounded-2xl"
          options={[
            { label: "Medium", value: "Medium" },
            { label: "Loud", value: "Loud" },
            { label: "X-Loud", value: "X-Loud" },
          ]}
          onChange={(value) => {
            setAdvancedAISetting({
              ...advancedAISetting,
              virtualGuard: {
                ...advancedAISetting?.virtualGuard,
                volume: value,
              },
            });
          }}
        />
      </div>
      <div className="mt-8 flex justify-between items-center">
        <span>Rate</span>
        <Select
          style={{ width: "calc(100% - 100px)" }}
          defaultValue={"Medium"}
          value={advancedAISetting?.virtualGuard?.rate}
          popupClassName="advancedAI-select-dropdown"
          className="h-10 rounded-2xl"
          options={[
            { label: "Medium", value: "Medium" },
            { label: "Loud", value: "Loud" },
            { label: "X-Loud", value: "X-Loud" },
          ]}
          onChange={(value) => {
            setAdvancedAISetting({
              ...advancedAISetting,
              virtualGuard: {
                ...advancedAISetting?.virtualGuard,
                rate: value,
              },
            });
          }}
        />
      </div> */}
        </div>

        <div className="bg-[#fafafa] p-6 rounded-2xl basis-[33%] ">
          <p className="font-semibold text-xl mb-3">Advance Algorithm</p>
          <div className="rounded-2xl bg-[#fafafa]">
            {advancedAISetting?.aiAlgoSettings?.algos?.map((algo) => {
              const disabled =
                (algo.name === "gun_detection" &&
                  !advancedAISetting?.enablePerson) ||
                (algo.name === "lpn_detection" &&
                  !advancedAISetting?.enableVehicle);
              const title = disabled
                ? algo.name === "gun_detection"
                  ? "Enable Process Human Alerts First"
                  : "Enable Process Vehicle Alerts First"
                : "";
              return (
                <Tooltip title={title} key={algo.name}>
                  <div className="flex  items-center justify-between py-3 gap-2">
                    <span
                      className={clsx(
                        "font-semibold",
                        disabled ? "text-gray-400" : "text-black",
                      )}
                    >
                      {algo.display}
                    </span>

                    <Switch
                      disabled={disabled}
                      onChange={() => {
                        setAdvancedAISetting({
                          ...advancedAISetting,
                          aiAlgoSettings: {
                            ...advancedAISetting?.aiAlgoSettings,
                            algos:
                              advancedAISetting?.aiAlgoSettings?.algos?.map(
                                (a) => {
                                  if (a.name === algo.name) {
                                    return {
                                      ...a,
                                      enabled: !a.enabled,
                                    };
                                  }
                                  return a;
                                },
                              ),
                          },
                        });
                      }}
                      checked={algo.enabled}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      onColor="#3E83F6"
                      offColor="#fff"
                      handleDiameter={20}
                      offHandleColor="#9E9E9E"
                      className="border border-zinc-200"
                      height={32}
                      width={52}
                    />
                  </div>
                </Tooltip>
              );
            })}
          </div>
        </div>
      </div>
      {showAiTip && (
        <div className="bg-[#fafafa] p-6 rounded-2xl mt-6 ">
          <div className="flex gap-1 font-semibold mb-4">
            <SvgToastInfo width="16" className="fill-neutral-500" /> Note
          </div>
          <p className="mb-4">
            Enabling these{" "}
            <span className="font-semibold">Advanced AI features</span>
            (including "Virtual Guard with IP/Camera Speaker") will activate the
            platform's advanced AI analytics capabilities. Once activated, the
            system will automatically analyze video data detected by your setup
            to support keyword-based searches in the Magic Search feature.
          </p>
          <p className="mb-4">
            Each use of these AI analytics features will deduct credits from
            your account's purchased (or pre-existing) AI credit balance. When
            the credits are depleted, you will need to purchase additional AI
            credits through the platform's{" "}
            <span className="font-semibold">
              "License - Purchasing AI Credit"{" "}
            </span>
            section to continue using these features.
          </p>
          <p className="mb-4">The cost of each processing is 1 Credit.</p>
          <Checkbox
            className="mr-2"
            onChange={(e) => {
              if (e.target.checked) {
                localStorage.setItem("showAiTip", "0");
              }
            }}
          />
          Don’t show this again
        </div>
      )}
      <Modal
        title={
          <p className="text-xl font-semibold">
            Do you want to disable "Process Human Alerts"?
          </p>
        }
        width={550}
        open={showDisableHumanAlertContirmModal}
        onOk={() => {
          setAdvancedAISetting({
            ...advancedAISetting,
            enablePerson: !advancedAISetting?.enablePerson,
          });
          setShowDisableHumanAlertContirmModal(false);
        }}
        closable={false}
        onCancel={() => setShowDisableHumanAlertContirmModal(false)}
        okText="Disable Anyway"
        cancelText="Cancel"
        okButtonProps={{
          className: "primaryButton",
        }}
        cancelButtonProps={{
          className: "primaryButton bordered",
        }}
      >
        <p className="mt-4 mb-4 break-normal">
          Disabling "Process Human Alerts" will permanently make "Gun Detection"
          unavailable until re-enabled.
        </p>
      </Modal>
    </div>
  );
}
